import React from "react";
import { Box, CircularProgress } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	size?: number;
};

export default function LoadingSpinner({ size = 40 }: Props) {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "200px",
			}}
		>
			<CircularProgress size={size} />
		</Box>
	);
}
